<template>
  <div class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container colum top-spacing">
      <h5 class="title m-0 text-uppercase c-body2 text-center">
        {{ $t("policyObj.text20") }}
      </h5>
      <div class="content mt-10">
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text21") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text22") }}
          <span class="fw-600">checktee.com</span> {{ $t("policyObj.text90") }}
        </p>
        <div class="ml-20">
          <p class="lh-18 m-0">• {{ $t("policyObj.text23") }};</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text24") }};</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text25") }};</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text26") }};</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text27") }};</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text28") }}</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text29") }}</p>
          <p class="lh-18">
            • {{ $t("policyObj.text30") }}
            <strong class="fw-600">Checktee.com</strong>;
          </p>
        </div>

        <p class="lh-18 fw-600">
          {{ $t("policyObj.text31") }}
        </p>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text32") }}
        </p>
        <div class="ml-20">
          <p class="lh-18 m-0">• {{ $t("policyObj.text33") }};</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text34") }}</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text35") }}</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text36") }}</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text37") }}</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text38") }}</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text39") }}</p>
          <p class="lh-18">
            • {{ $t("policyObj.text40") }}
            <strong class="fw-600">Checktee.com</strong>;
          </p>
          <p class="lh-18">
            • {{ $t("policyObj.text41") }}: Website
            <strong class="fw-600">Checktee.com</strong>
            {{ $t("policyObj.text42") }}
          </p>
        </div>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text43") }}
        </p>
        <div class="ml-20">
          <p class="lh-18 m-0">• {{ $t("policyObj.text44") }}</p>
          <p class="lh-18">• {{ $t("policyObj.text45") }}</p>
        </div>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text46") }}
        </p>
        <p class="lh-18">
          {{ $t("policyObj.text47") }}
        </p>

        <div class="ml-20">
          <p class="lh-18 m-0">• {{ $t("policyObj.text48") }}</p>
          <p class="lh-18 ">• {{ $t("policyObj.text49") }}</p>
        </div>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text50") }}
        </p>

        <div class="ml-20">
          <p class="lh-18 m-0">• {{ $t("policyObj.text48") }}</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text51") }}</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text52") }}</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text53") }}</p>
          <p class="lh-18 ">
            • Website: <strong class="fw-600">checktee.com</strong>
          </p>
        </div>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text54") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text55") }}
        </p>
        <p class="lh-18 fw-600">
          {{ $t("policyObj.text56") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text57") }}
          <strong class="fw-600">Checktee.com</strong>
          {{ $t("policyObj.text58") }}
        </p>
        <p class="lh-18">
          {{ $t("policyObj.text59") }}
          <strong class="fw-600">Checktee.com</strong>
          {{ $t("policyObj.text60") }}
          <strong class="fw-600">Checktee.com</strong>
          {{ $t("policyObj.text61") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text62") }}
          <strong class="fw-600">Checktee.com</strong>
          {{ $t("policyObj.text63") }}
          <strong class="fw-600">Checktee.com</strong>
        </p>

        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text64") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text65") }}
          <strong class="fw-600">Booking</strong> {{ $t("policyObj.text66") }}
        </p>
        <div class="ml-20">
          <p class="lh-18 m-0">
            {{ $t("policyObj.text67") }}
            <strong class="fw-600">Checktee.com</strong>
            {{ $t("policyObj.text68") }}
          </p>
          <div class="ml-20">
            <p class="lh-18 m-0">
              • {{ $t("policyObj.text69") }}
              <strong class="fw-600">Booking</strong>
              {{ $t("policyObj.text70") }}
            </p>
            <p class="lh-18 m-0">• {{ $t("policyObj.text71") }}</p>
          </div>
          <p class="lh-18 m-0">- {{ $t("policyObj.text72") }}</p>
          <p class="lh-18 ">- {{ $t("policyObj.text73") }}</p>
        </div>

        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text74") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text75") }}
          <strong class="fw-600">Checktee.com</strong>
          {{ $t("policyObj.text76") }}
          <strong class="fw-600">Checktee.com</strong>
          {{ $t("policyObj.text77") }}
        </p>
        <div class="ml-20">
          <p class="lh-18 m-0">• {{ $t("policyObj.text78") }}</p>
          <p class="lh-18 m-0">• {{ $t("policyObj.text79") }}</p>
          <p class="lh-18 ">• {{ $t("policyObj.text80") }}</p>
        </div>

        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text81") }}
        </p>
        <p class="lh-18 ">
          <span class="fw-600">{{ $t("policyObj.text82") }}</span
          >{{ $t("policyObj.text83") }}
        </p>
        <p class="lh-18 ">
          <span class="fw-600">{{ $t("policyObj.text84") }}</span>
          {{ $t("policyObj.text85") }}
        </p>
        <p class="lh-18 ">
          <span class="fw-600">{{ $t("policyObj.text86") }}</span
          >{{ $t("policyObj.text87") }}
        </p>
        <p class="lh-18 ">
          <span class="fw-600">{{ $t("policyObj.text88") }}</span>
          {{ $t("policyObj.text89") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";

export default {
  name: "police-delivery",
  computed: {},
  components: {
    MainNavBarWapV2
  },
  props: {},
  data() {
    return {
      infoHeader: {
        title: this.$t("policyObj.text19"),
        isShowHomeIcon: true,
        isShowMenu: true
      }
    };
  },
  created() {}
};
</script>
<style scoped>
.top-spacing {
  padding-top: 100px;
}
@media screen and (min-width: 0px) and (max-width: 991px) {
  .top-spacing {
    padding-top: 60px;
  }
}
</style>
